import { render, staticRenderFns } from "./CultureView.vue?vue&type=template&id=c3801434&scoped=true"
import script from "./CultureView.vue?vue&type=script&lang=js"
export * from "./CultureView.vue?vue&type=script&lang=js"
import style0 from "./CultureView.vue?vue&type=style&index=0&id=c3801434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3801434",
  null
  
)

export default component.exports